import * as v from "valibot";
import { rpcContract } from "../rpc";

export const banChatUserRpcContract = rpcContract({
  name: "ban-chat-user",
  paramsSchema: v.object({
    scope: v.picklist(["live", "community"]),
    scopeId: v.pipe(v.string(), v.uuid()),
    userId: v.pipe(v.string(), v.uuid()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    errorMessage: v.optional(v.string()),
  }),
});

export type BanChatUserParams = v.InferOutput<typeof banChatUserRpcContract.paramsSchema>;
export type BanChatUserResult = v.InferOutput<typeof banChatUserRpcContract.resultSchema>;
